import { BonanzaCoinLoader, Box } from '@bonanza-social/moonlight';
import { memo } from 'react';

function MetaGameLoading() {
  return (
    <Box flex={1} justifyContent="center" alignItems="center">
      <Box width={80} height={80} marginBottom="space-600">
        <BonanzaCoinLoader />
      </Box>
    </Box>
  );
}

export default memo(MetaGameLoading);
